import { getEditLocation } from "../../../core/util/functions";
export const stockFeeLocation = "/cliring/administrativetasks/importstockfees";
export const getStockFeesEditLocation = (id?: string) =>
  getEditLocation(stockFeeLocation, undefined, id);

export const editRouter = getStockFeesEditLocation(":id?");
